import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../config/firebaseConfig';
import { toast } from 'react-toastify';

const AddTariffsModal = ({ show, handleClose }) => {
  const [formData, setFormData] = useState({
    type: '',
    value: '',
    price: '',
    currency: '',
    date: '',
    info: '',
    isSubcontractor: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formattedData = {
        ...formData,
        price: Number(formData.price)
      };
      
      await addDoc(collection(db, 'Tariffs'), formattedData);
      toast.success('Tarife başarıyla eklendi');
      handleClose();
    } catch (error) {
      console.error('Error adding tariff:', error);
      toast.error('Tarife eklenirken bir hata oluştu');
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Tarife Ekle</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Tarife Tipi</Form.Label>
            <Form.Select
              value={formData.type}
              onChange={(e) => setFormData({...formData, type: e.target.value})}
            >
              <option>Lütfen Seçiniz</option>
              <option value="FTE">FTE</option>
              <option value="Saat">Saat</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Tarife Değer</Form.Label>
            <div>
              <input
                type="number"
                min="0"
                max="1"
                step="0.01"
                value={formData.value}
                onChange={(e) => {
                  const value = parseFloat(e.target.value);
                  if (value >= 0 && value <= 1) {
                    setFormData({ ...formData, value: value.toString() });
                  }
                }}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  borderRadius: '4px',
                  border: '1px solid #32363a',
                  backgroundColor: '#2c2f33',
                  color: '#ffffff',
                  marginTop: '0.25rem'
                }}
              />
            </div>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Fiyat</Form.Label>
            <Form.Control
              type="number"
              value={formData.price}
              onChange={(e) => setFormData({...formData, price: e.target.value})}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Döviz Tipi</Form.Label>
            <Form.Select
              value={formData.currency}
              onChange={(e) => setFormData({...formData, currency: e.target.value})}
            >
              <option>Lütfen Seçiniz</option>
              <option value="TRY">TRY</option>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Tarih</Form.Label>
            <Form.Control
              type="date"
              value={formData.date}
              onChange={(e) => setFormData({...formData, date: e.target.value})}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Bilgi</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={formData.info}
              onChange={(e) => setFormData({...formData, info: e.target.value})}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Subcontractor?</Form.Label>
            <Form.Select
              value={formData.isSubcontractor}
              onChange={(e) => setFormData({...formData, isSubcontractor: e.target.value})}
            >
              <option>Lütfen Seçiniz</option>
              <option value="Evet">Evet</option>
              <option value="Hayır">Hayır</option>
            </Form.Select>
          </Form.Group>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" onClick={handleClose}>
              Kapat
            </Button>
            <Button variant="secondary" type="button" onClick={() => setFormData({
              type: '',
              value: '',
              price: '',
              currency: '',
              date: '',
              info: '',
              isSubcontractor: ''
            })}>
              Temizle
            </Button>
            <Button variant="primary" type="submit">
              Ekle
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddTariffsModal;